const mapObj = {};

mapObj.accountMap = function () {
    const maps = document.querySelectorAll(".account-map__container");

    if (maps != null && maps.length) {

        maps.forEach(function (map, index) {
            map.id = `account-map${index}`;

            if (!map.childNodes.length) {

                ymaps.ready(function () {
                    var myMap = new ymaps.Map(`account-map${index}`, {
                        center: [55.7539, 37.6208],
                        zoom: 12,
                    });

                    myMap.behaviors.disable('scrollZoom');

                    const addressListeners = function () {
                        const mapContainer = map.closest('.js-address-parent');
                        const cityInputs = mapContainer.querySelectorAll(".js-map-city");
                        const cityInput = mapContainer.querySelector(".js-map-city");
                        const streetInput = mapContainer.querySelector(".js-map-street");
                        const houseNumberInput = mapContainer.querySelector(".js-map-house-number");
                        const structureInput = mapContainer.querySelector(".js-map-structure");
                        const officeInput = mapContainer.querySelector(".js-map-office");
                        const pinSrc = map.getAttribute('data-pin-src');

                        let typingTimer;
                        const doneTypingInterval = 500;

                        const doneTyping = function ($this) {
                            getSearchRequest($this);
                        };

                        const listeners = function () {
                            cityInput.addEventListener("keyup", function () {
                                clearTimeout(typingTimer);
                                typingTimer = setTimeout(() => {
                                    doneTyping(this);
                                }, doneTypingInterval);
                            });

                            cityInput.addEventListener("keydown", function () {
                                clearTimeout(typingTimer);
                            });

                            streetInput.addEventListener("keyup", function () {
                                clearTimeout(typingTimer);
                                typingTimer = setTimeout(() => {
                                    doneTyping(this);
                                }, doneTypingInterval);
                            });

                            streetInput.addEventListener("keydown", function () {
                                clearTimeout(typingTimer);
                            });

                            houseNumberInput.addEventListener("keyup", function () {
                                clearTimeout(typingTimer);
                                typingTimer = setTimeout(() => {
                                    doneTyping(this);
                                }, doneTypingInterval);
                            });

                            houseNumberInput.addEventListener("keydown", function () {
                                clearTimeout(typingTimer);
                            });

                            structureInput.addEventListener("keyup", function () {
                                clearTimeout(typingTimer);
                                typingTimer = setTimeout(() => {
                                    doneTyping(this);
                                }, doneTypingInterval);
                            });

                            structureInput.addEventListener("keydown", function () {
                                clearTimeout(typingTimer);
                            });

                            officeInput.addEventListener("keyup", function () {
                                clearTimeout(typingTimer);
                                typingTimer = setTimeout(() => {
                                    doneTyping(this);
                                }, doneTypingInterval);
                            });

                            officeInput.addEventListener("keydown", function () {
                                clearTimeout(typingTimer);
                            });
                        };

                        const getSearchRequest = function ($this) {
                            let valueList = [];
                            const parent = $this.closest(".js-address-parent");
                            const cityValue = parent.querySelector(".js-map-city").value;
                            const streetValue = parent.querySelector(".js-map-street").value;
                            const houseValue = parent.querySelector(".js-map-house-number").value;
                            const structureValue = parent.querySelector(".js-map-structure").value;
                            const officeValue = parent.querySelector(".js-map-office").value;
                            let hiddenInput =  parent.querySelector(".js-map-coords");
                            let hiddenInputCoords = hiddenInput.value;
                            let hiddenInputData = parent.querySelector('.js-map-coords').dataset.firstLoad;


                            // valueList
                            valueList = [];
                            valueList.push(cityValue, streetValue, houseValue, structureValue, officeValue);

                            let searchRequest = valueList.join(" ");


                            if (!hiddenInputData && hiddenInputCoords) {
                                searchRequest = hiddenInputCoords.split(',');
                                getCoordsPosition();
                                hiddenInput.setAttribute('data-first-load', 'y');
                            } else {
                                getInputsPosition();
                            }

                            console.log(222);


                            function getInputsPosition() {

                                ymaps.geocode(searchRequest, {
                                    results: 1
                                }).then(function (res) {
                                    var firstGeoObject = res.geoObjects.get(0),
                                        coords = firstGeoObject.geometry.getCoordinates(),
                                        bounds = firstGeoObject.properties.get("boundedBy");

                                    const geolocationResult = firstGeoObject.properties.get("metaDataProperty.GeocoderMetaData").text;

                                    var myPlacemark = new ymaps.Placemark(coords, {
                                        iconContent: "",
                                        balloonContent: geolocationResult,
                                        hintContent: geolocationResult
                                    }, {
                                        iconLayout: "default#image",
                                        iconImageHref: pinSrc,
                                        iconImageSize: [
                                            35, 47
                                        ],
                                        iconImageOffset: [
                                            -14, -46
                                        ],
                                        draggable: true
                                    });

                                    myMap.geoObjects.removeAll();
                                    myMap.geoObjects.add(myPlacemark);

                                    const currentMap = myMap.container._parentElement;
                                    const currentMapParent = currentMap.closest(".js-address-parent");
                                    let inputHidden = currentMapParent.querySelector(".js-map-coords");
                                    setCoords(inputHidden, coords)

                                    myPlacemark.events.add("dragend", function (e) {
                                        myPlacemark.geometry.setCoordinates(myPlacemark.geometry.getCoordinates());
                                        getAddress(myPlacemark.geometry.getCoordinates());
                                    });

                                    function getAddress(coords) {
                                        myPlacemark.properties.set("iconCaption", "поиск...");
                                        ymaps.geocode(coords).then(function (res) {
                                            const firstGeoObject = res.geoObjects.get(0);
                                            const cityValue = firstGeoObject.getLocalities()[0];
                                            const streetValue = firstGeoObject.getThoroughfare();
                                            const streetNumberValue = firstGeoObject.getPremiseNumber();


                                            // dom elements
                                            const currentMap = myMap.container._parentElement;
                                            const currentMapParent = currentMap.closest(".js-address-parent");

                                            const cityInput = currentMapParent.querySelector(".js-map-city");
                                            const streetInput = currentMapParent.querySelector(".js-map-street");
                                            const streetNumberInput = currentMapParent.querySelector(".js-map-house-number");
                                            let inputHidden = currentMapParent.querySelector(".js-map-coords");


                                            setInputValuesAfterDrag(cityInput, cityValue);
                                            setInputValuesAfterDrag(streetInput, streetValue);
                                            setInputValuesAfterDrag(streetNumberInput, streetNumberValue);
                                            setCoords(inputHidden, coords)

                                            myPlacemark.properties.set({
                                                iconCaption: [
                                                    firstGeoObject.getLocalities().length ?
                                                        firstGeoObject.getLocalities() :
                                                        firstGeoObject.getAdministrativeAreas(),
                                                    firstGeoObject.getThoroughfare() || firstGeoObject.getPremise()
                                                ].filter(Boolean).join(", "),
                                                balloonContent: firstGeoObject.getAddressLine(),
                                                hintContent: firstGeoObject.getAddressLine()
                                            });

                                        });

                                    }

                                    myMap.setBounds(bounds, {
                                        checkZoomRange: true
                                    });
                                });
                            }

                            function getCoordsPosition() {
                                ymaps.geocode(searchRequest, {
                                    results: 1
                                }).then(function (res) {
                                    var firstGeoObject = res.geoObjects.get(0),
                                        coords = searchRequest;
                                        bounds = firstGeoObject.properties.get("boundedBy");

                                    const geolocationResult = firstGeoObject.properties.get("metaDataProperty.GeocoderMetaData").text;

                                    var myPlacemark = new ymaps.Placemark(coords, {
                                        iconContent: "",
                                        balloonContent: geolocationResult,
                                        hintContent: geolocationResult
                                    }, {
                                        iconLayout: "default#image",
                                        iconImageHref: pinSrc,
                                        iconImageSize: [
                                            35, 47
                                        ],
                                        iconImageOffset: [
                                            -14, -46
                                        ],
                                        draggable: true
                                    });

                                    myMap.geoObjects.removeAll();
                                    myMap.geoObjects.add(myPlacemark);

                                    myPlacemark.events.add("dragend", function (e) {
                                        myPlacemark.geometry.setCoordinates(myPlacemark.geometry.getCoordinates());
                                        getAddress(myPlacemark.geometry.getCoordinates());
                                    });

                                    function getAddress(coords) {
                                        myPlacemark.properties.set("iconCaption", "поиск...");
                                        ymaps.geocode(coords).then(function (res) {
                                            const firstGeoObject = res.geoObjects.get(0);
                                            const cityValue = firstGeoObject.getLocalities()[0];
                                            const streetValue = firstGeoObject.getThoroughfare();
                                            const streetNumberValue = firstGeoObject.getPremiseNumber();


                                            // dom elements
                                            const currentMap = myMap.container._parentElement;
                                            const currentMapParent = currentMap.closest(".js-address-parent");

                                            const cityInput = currentMapParent.querySelector(".js-map-city");
                                            const streetInput = currentMapParent.querySelector(".js-map-street");
                                            const streetNumberInput = currentMapParent.querySelector(".js-map-house-number");
                                            let inputHidden = currentMapParent.querySelector(".js-map-coords");


                                            setInputValuesAfterDrag(cityInput, cityValue);
                                            setInputValuesAfterDrag(streetInput, streetValue);
                                            setInputValuesAfterDrag(streetNumberInput, streetNumberValue);
                                            setCoords(inputHidden, coords)

                                            myPlacemark.properties.set({
                                                iconCaption: [
                                                    firstGeoObject.getLocalities().length ?
                                                        firstGeoObject.getLocalities() :
                                                        firstGeoObject.getAdministrativeAreas(),
                                                    firstGeoObject.getThoroughfare() || firstGeoObject.getPremise()
                                                ].filter(Boolean).join(", "),
                                                balloonContent: firstGeoObject.getAddressLine(),
                                                hintContent: firstGeoObject.getAddressLine()
                                            });

                                        });

                                    }

                                    myMap.setBounds(bounds, {
                                        checkZoomRange: true
                                    });
                                });
                            }

                        };

                        const setInputValuesAfterDrag = function (key, value) {
                            if (value) {
                                key.value = value;
                            } else {
                                key.value = "";
                            }
                        };

                        const setCoords = function (key, coords) {
                            if (coords) {
                                key.value = coords;
                            } else {
                                key.value = "";
                            }
                        };

                        listeners();

                        if (cityInputs != null) {
                            cityInputs.forEach(function (elem) {
                                getSearchRequest(elem);
                            });
                        }
                    };

                    addressListeners();
                });

            };
        });
    }
};

mapObj.accountMap();